<template>
  <component
    :is="modal.component"
    v-if="modal"
    v-bind="modal.props"
    :class="{ 'd-block': modal.component }"
  />
</template>

<script>
export default {
  name: 'VpModalRoot',
  inject: {
    suite: {
      default: 'unknown',
    },
  },
  provide() {
    return {
      close: this.close,
    };
  },
  data() {
    return {
      modal: {},
    };
  },
  methods: {
    open(component, props) {
      const { body } = document;

      // Google Analytics Event
      if (this.$gtag) {
        setTimeout(() => {
          this.$gtag.event('modal_open', {
            suite: this.suite,
            modal_name: component.name,
          });
        }, 100);
      }

      const middle = document.getElementById('vp-middle');
      body.style.height = '100vh';
      body.style.overflowY = 'hidden';

      // Without this style z-index change,
      // the modal window won't go over the header,
      // actionbar or side menu on the utility app.
      if (middle) {
        middle.style.zIndex = 100;
        middle.style.overflowY = 'hidden';
      }

      this.modal = {
        component,
        props,
      };
    },
    close() {
      const { body } = document;
      const { props, component } = this.modal;
      let modalName;

      if (component) modalName = component.name;

      // Google Analytics Event
      if (this.$gtag && modalName) {
        setTimeout(() => {
          this.$gtag.event('modal_close', {
            suite: this.suite,
            modal_name: modalName,
          });
        }, 100);
      }

      const middle = document.getElementById('vp-middle');
      body.style.position = '';
      body.style.top = '';
      body.style.overflowY = '';

      // After modal is closed, vp-middle element
      // is reset to it's normal z-index.
      if (middle) {
        middle.style.zIndex = 1;
        middle.style.overflowY = '';
      }
      if (props && props.close) this.modal.props.close();
      if (props && props.pointOfRegard) {
        props.pointOfRegard.focus();
      }
      this.modal = {};
    },
  },
};
</script>

<style scoped>
.d-block {
  display: block;
}
</style>
